/** Products visible on the customer marketplace (approved or legacy without status). */
export const isMarketplaceVisibleProduct = (product) => {
  if (!product) return false;
  const status = product.approvalStatus;
  return !status || status === "approved";
};

export const filterMarketplaceProducts = (products) =>
  (products || []).filter(isMarketplaceVisibleProduct);

const LIST_KEYS = ["products", "hotDealProducts", "trendingProducts", "todaysDealProducts"];

/** Strip non-approved products from common API response shapes. */
export const filterMarketplacePayload = (payload) => {
  if (!payload || typeof payload !== "object") return payload;

  const next = { ...payload };
  let changed = false;

  for (const key of LIST_KEYS) {
    if (Array.isArray(next[key])) {
      const filtered = filterMarketplaceProducts(next[key]);
      if (filtered.length !== next[key].length) {
        next[key] = filtered;
        changed = true;
      }
    }
  }

  if (changed && typeof next.totalProducts === "number") {
    next.totalProducts = LIST_KEYS.reduce(
      (max, key) => (Array.isArray(next[key]) ? Math.max(max, next[key].length) : max),
      0
    );
  }

  if (changed && typeof next.count === "number" && Array.isArray(next.products)) {
    next.count = next.products.length;
  }

  return next;
};
